/**
 * Component: Site navigation
 */


var ed = ed || {};

ed.siteNavigation = new function(){
    /**
     * Init function
     */
    this.init = function() {
        openMobileNavigation();
        siteNavigationDropdown();
        siteNavigationSubDropdown();
    };

    /**
     * Dropdown function for the site navigation
     */
    function siteNavigationDropdown() {
        $('.site-navigation__dropdown-trigger').on('click', function(e){
            e.preventDefault();

            var parent = $(this).parent('.site-navigation__item');

            if (!parent.hasClass('active')) {
                $(this).text('-');
                parent.addClass('active');
            }
            else {
                $(this).text('+');
                parent.removeClass('active');
            }
        });
    }

    function siteNavigationSubDropdown() {
        $('.site-navigation-dropdown__dropdown-trigger').on('click', function(e){
            e.preventDefault();

            var parent = $(this).parent('.site-navigation-dropdown__item');

            if (!parent.hasClass('active')) {
                $(this).text('-');
                parent.addClass('active');
            }
            else {
                $(this).text('+');
                parent.removeClass('active');
            }
        });
    }

    /**
     * Mobile navigation trigger
     */
    function openMobileNavigation() {
        $('#site-navigation-button, #site-navigation-button-close').on('click', function(){
            if (!$('#site-navigation').hasClass('open')) {
                $('#site-navigation').addClass('open');

                ed.overlay.backdrop();
            }
            else {
                // Remove classes
                $('#site-navigation').removeClass('open');

                ed.overlay.destroy();
            }
        });
    }

    /**
     * Place site navigation
     * We move the site navigation outside of the site-header, to make the backdrop look neat
     */
    this.place = function() {
        var siteNavigation = $('#site-navigation'),
            siteHeader = $('#site-header'),
            topNavigation = $('#top-navigation');

        if (window.innerWidth < 1025) {
            // mobile view
            siteNavigation.insertAfter(siteHeader);
        }
        else {
            // desktop view
            siteNavigation.insertAfter(topNavigation);
        }
    };

};
